export default (open, selected, rows) => ({
    open,
    selected,
    rows,
    shortcuts: {
        ['@click.outside']() {
            this.open = false
        },
        ['@keyup.enter']() {
            if (this.selected === null) {
                return
            }

            const index = this.rows.findIndex(row => row.id == this.selected)
            const row = this.rows[index]
            this.pickOption(row.email)
        },
        ['@keyup.esc']() {
            this.open = false
        },
        ['@keyup.up']() {
            if (!this.open) {
                return
            }

            let row

            if (this.selected === null) {
                row = this.rows[this.rows.length - 1]
                return this.selectOption(row.email)
            }

            const index = this.rows.findIndex(row => row.email == this.selected)

            if (this.rows[index - 1] === undefined) {
                row = this.rows[this.rows.length - 1];
                return this.selectOption(row.email)
            }

            row = this.rows[index - 1];
            return this.selectOption(row.email)
        },
        ['@keyup.down']() {
            if (!this.open) {
                return this.open = true
            }

            let row

            if (this.selected === null) {
                row = this.rows[0]
                return this.selectOption(row.id)
            }

            const index = this.rows.findIndex(row => row.email == this.selected)

            if (this.rows[index + 1] === undefined) {
                row = this.rows[0]
                return this.selectOption(row.id)
            }

            row = this.rows[index + 1]
            return this.selectOption(row.id)
        },
    },
    selectOption(value) {
        this.selected = value
    },
    pickOption(value) {
        this.selectOption(value)
        this.open = false
    },
    fillInputWithSelectedValue(value) {
        this.$refs['search-input'].value = value || '';
    },
    init() {
        this.$watch('selected', value => this.fillInputWithSelectedValue(value));
        this.$wire.$watch('useScopes', (value) => {
            this.$wire.updateRows();
        });

        this.$nextTick(() => {
            this.fillInputWithSelectedValue(this.selected);
        })
    }
})
